import { render, staticRenderFns } from "./CreateDepartmentModal.vue?vue&type=template&id=68f5c018&scoped=true"
import script from "./CreateDepartmentModal.vue?vue&type=script&lang=js"
export * from "./CreateDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDepartmentModal.vue?vue&type=style&index=0&id=68f5c018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5c018",
  null
  
)

export default component.exports